import Vue from 'vue';
import * as Sentry from '@sentry/vue';

const sentryEnv = process.env.VUE_APP_SENTRY_ENVIRONMENT;

if (sentryEnv) {
  Sentry.init({
    Vue,
    dsn: 'https://ce3a59e598e757363eeb930cebe7fe99@logs.smoothr.de/4',
    environment: sentryEnv,
    release: process.env.npm_package_version,
    integrations: [
      Sentry.feedbackIntegration({
        autoInject: false,
      }),
    ],
    // Optional: add integrations, tracesSampleRate, etc.
    beforeSend(event) {
      // Optionally filter or modify events here
      return event;
    },
  });
}

export { Sentry };
